export enum DisplayMode {
  DISABLE = "disable",
  ENABLE = "enable",
  PC_ONLY = "PC-only",
  MOBILES_ONLY = "mobiles-only"
}